import { createAsyncThunk } from "@reduxjs/toolkit";
import customFetch from "../../util/config/axiosConfig";
import { getDataUserId } from "../../util/manageAuth";
import {
    DbAddConnectionRequest,
    DbAddConnectionResponse,
    DbConnection,
} from "../../types/databaseTypes";
import { ApiResponse } from "../../types/responseType";

export const addDBConnection = createAsyncThunk<
    DbAddConnectionResponse,
    DbAddConnectionRequest
>(
    "databaseConnections/add",
    async (connectionData, thunkAPI) => {
        try {
            const userId = getDataUserId();

            const response = await customFetch.post(`/api/database-connections`, {
                ...connectionData,
                userId,
            });

            return response.data?.data ?? response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(
                error?.response?.data?.error?.message ||
                error?.message ||
                "Failed to add database connection"
            );
        }
    }
);

export const fetchDBConnections = createAsyncThunk<
    DbConnection[],
    void,
    { rejectValue: string }
>(
    "database/fetchDBConnections",
    async (_, thunkAPI) => {
        try {
           
            const response = await customFetch.get(
                "/api/database-connections"
            );
            let payload = response.data;

            if (typeof payload?.data === "string") {
                payload.data = JSON.parse(payload.data);
            }

            return payload.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(
                error?.message || "Failed to fetch database connections"
            );
        }
    }
);

export const deleteDBConnection = createAsyncThunk<
    void,
    number,
    { rejectValue: string }
>(
    "databaseConnections/delete",
    async (id, thunkAPI) => {
        try {
            await customFetch.delete(`/api/database-connections/${id}`)
        } catch (error: any) {
            return thunkAPI.rejectWithValue(
                error?.response?.data?.error?.message ||
                error?.message ||
                "Failed to delete database connection"
            )
        }
    }
)

export const updateDBConnection = createAsyncThunk<
    DbAddConnectionResponse,
    DbAddConnectionRequest & { id: number },
    { rejectValue: string }
>(
    "databaseConnections/update",
    async ({ id, ...connectionData }, thunkAPI) => {
        try {
            const userId = getDataUserId()

            const response = await customFetch.put(`/api/database-connections/${id}`, {
                id,
                ...connectionData,
                userId,
            })

            return response.data?.data ?? response.data
        } catch (error: any) {
            return thunkAPI.rejectWithValue(
                error?.response?.data?.error?.message ||
                error?.message ||
                "Failed to update database connection"
            )
        }
    }
)